// extracted by mini-css-extract-plugin
export default {"body":"Bio_body__gImgH","image":"Bio_image__9e9-2","image-holder":"Bio_image-holder__ALb+U","text":"Bio_text__thaXJ"};